{
  "INBOX_MGMT": {
    "HEADER": "Schránky",
    "DESCRIPTION": "Kanál je způsob komunikace, který váš zákazník zvolí pro interakci s vámi. Schránka je místo, kde spravujete interakce pro konkrétní kanál. Může zahrnovat komunikaci z různých zdrojů, jako je e-mail, živý chat a sociální média.",
    "LEARN_MORE": "Zjistěte více o schránkách",
    "RECONNECT": {
      "BUTTON": "Znovu připojit",
      "FACEBOOK": "Připojení k Facebooku vypršelo nebo bylo zrušeno. Zprávy odeslané na stránku do této schránky nedorazí a odpovědi se nemusí odeslat. Člověk, který spravuje facebookovou stránku, musí kliknout na Znovu připojit a přihlásit se k Facebooku.",
      "INSTAGRAM": "Připojení k Instagramu vypršelo nebo bylo zrušeno. Zprávy odeslané na účet do této schránky nedorazí a odpovědi se nemusí odeslat. Klikněte na Znovu připojit a přihlaste se ke stejnému instagramovému účtu. Jiný účet vytvoří novou schránku.",
      "GOOGLE": "Připojení ke Googlu vypršelo nebo bylo zrušeno. Nové e-maily do této schránky nedorazí a odpovědi se nemusí odeslat. Klikněte na Znovu připojit a přihlaste se ke Googlu jako {email}.",
      "MICROSOFT": "Připojení k Microsoftu vypršelo nebo bylo zrušeno. Nové e-maily do této schránky nedorazí a odpovědi se nemusí odeslat. Klikněte na Znovu připojit a přihlaste se k Microsoftu jako {email}.",
      "ALLEGRO": "Připojení k Allegru vypršelo nebo bylo zrušeno. Zprávy od kupujících do této schránky nedorazí a odpovědi se nemusí odeslat. Klikněte na Znovu připojit a přihlaste se do Allegra jako prodejce {seller}. Jiný prodejní účet vytvoří novou schránku.",
      "IMAP_LOGIN": "Poštovní server odmítá přihlášení k IMAP jako {login}. Nové e-maily do této schránky nedorazí. Zkontrolujte přihlašovací jméno a heslo pro IMAP na kartě {tab} a uložte je. Přihlášení zkoušíme dál a schránka se obnoví, jakmile přihlášení projde.",
      "WHATSAPP": "Připojení k WhatsAppu vypršelo nebo bylo zrušeno. Přílohy od zákazníků do této schránky nedorazí a odpovědi mohou selhat. Klikněte na Znovu připojit, přihlaste se k Facebooku a znovu vyberte číslo {phone}."
    },
    "LIST": {
      "404": "K tomuto účtu nejsou připojeny žádné doručené schránky.",
      "RECONNECT_REQUIRED": "Je nutné znovu připojit"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Vybrat kanál",
        "BODY": "Vyberte si poskytovatele, který chcete integrovat."
      },
      "INBOX": {
        "TITLE": "Vytvořit doručenou poštu",
        "BODY": "Ověřte si svůj účet a vytvořte si doručenou poštu."
      },
      "AGENT": {
        "TITLE": "Přidat agenty",
        "BODY": "Přidat agenty do vytvořené schránky."
      },
      "FINISH": {
        "TITLE": "Hotovo!",
        "BODY": "Vše je nastaveno!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Název schránky",
        "PLACEHOLDER": "Zadejte název vaší schránky (např. Acme Inc)",
        "ERROR": "Zadejte prosím platný název schránky"
      },
      "WEBSITE_NAME": {
        "LABEL": "Název webových stránek",
        "PLACEHOLDER": "Zadejte název vašich webových stránek (např. Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Interní název",
        "PLACEHOLDER": "Název pro lepší identifikaci kanálu v administraci",
        "ERROR": "Prosím zadejte unikátní název kanálu"
      },
      "FB": {
        "HELP": "PS: Přihlášením získáme přístup pouze ke zprávám vaší stránky. Vaše soukromé zprávy nám nikdy nemohou být přístupné.",
        "CHOOSE_PAGE": "Vybrat stránku",
        "CHOOSE_PLACEHOLDER": "Vyberte stránku ze seznamu",
        "INBOX_NAME": "Název schránky",
        "ADD_NAME": "Zadejte název schránky",
        "PICK_NAME": "Vyberte název pro vaši schránku",
        "PICK_A_VALUE": "Vyberte hodnotu",
        "CREATE_INBOX": "Vytvořit schránku"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Pokračovat s Instagramem",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Propojte svůj Instagram profil",
        "HELP": "Chcete-li přidat svůj Instagram profil jako kanál, musíte ověřit svůj Instagram profil kliknutím na tlačítko 'Pokračovat s Instagramem' ",
        "ERROR_MESSAGE": "Při připojování k Instagramu došlo k chybě, zkuste to prosím znovu",
        "ERROR_AUTH": "Při připojování k Instagramu došlo k chybě, zkuste to prosím znovu",
        "NEW_INBOX_SUGGESTION": "Tento Instagram účet byl dříve propojen s jinou schránkou a nyní byl migrován sem. Všechny nové zprávy se budou zobrazovat zde. Stará schránka již nebude moci odesílat ani přijímat zprávy pro tento účet.",
        "DUPLICATE_INBOX_BANNER": "Tento Instagram účet byl migrován do nové Instagram schránky. V této schránce již nebudete moci odesílat/přijímat Instagram zprávy."
      },
      "TWITTER": {
        "HELP": "Chcete-li přidat svůj Twitter profil jako kanál, musíte ověřit svůj Twitter profil kliknutím na tlačítko 'Přihlásit se přes Twitter' ",
        "ERROR_MESSAGE": "Při připojování k Twitteru došlo k chybě, zkuste to prosím znovu",
        "TWEETS": {
          "ENABLE": "Vytvářet konverzace ze zmíněných tweetů"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Kanál webové stránky",
        "DESC": "Vytvořte si kanál pro vaše webové stránky a začněte podporovat své zákazníky prostřednictvím našeho widgetu.",
        "LOADING_MESSAGE": "Vytváření podpůrného kanálu webových stránek",
        "CHANNEL_AVATAR": {
          "LABEL": "Avatar kanálu"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "URL webového háčku",
          "PLACEHOLDER": "Zadejte prosím vaši URL webového háčku",
          "ERROR": "Zadejte prosím platnou URL"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Doména webových stránek",
          "PLACEHOLDER": "Zadejte doménu webu (např. acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Nadpis uvítání",
          "PLACEHOLDER": "Ahoj!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Text pro uvítání",
          "PLACEHOLDER": "Snadno se s námi spojujeme. Požádejte nás o cokoliv, nebo sdílejte svou zpětnou vazbu."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Pozdrav",
          "PLACEHOLDER": "Acme Inc obvykle odpovídá do několika hodin."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Povolit uvítání",
          "HELP_TEXT": "Automaticky odeslat uvítací zprávu, když je vytvořena nová konverzace.",
          "ENABLED": "Povoleno",
          "DISABLED": "Zakázáno"
        },
        "REPLY_TIME": {
          "TITLE": "Nastavit čas odpovědi",
          "IN_A_FEW_MINUTES": "Do několika minut",
          "IN_A_FEW_HOURS": "Do několika hodin",
          "IN_A_DAY": "Do dne",
          "HELP_TEXT": "Tento čas odpovědi bude zobrazen na widgetu"
        },
        "WIDGET_COLOR": {
          "LABEL": "Barva widgetu",
          "PLACEHOLDER": "Aktualizovat barvu widgetu použitou ve widgetu"
        },
        "SUBMIT_BUTTON": "Vytvořit doručenou poštu",
        "API": {
          "ERROR_MESSAGE": "Nepodařilo se nám vytvořit kanál webových stránek, zkuste to prosím znovu"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp kanál",
        "DESC": "Integrujte Twilio a začněte podporovat své zákazníky prostřednictvím SMS nebo WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "SID účtu",
          "PLACEHOLDER": "Zadejte SID vašeho Twilio účtu",
          "ERROR": "Toto pole je povinné"
        },
        "API_KEY": {
          "USE_API_KEY": "Použít ověření API klíčem",
          "LABEL": "SID API klíče",
          "PLACEHOLDER": "Zadejte prosím SID vašeho API klíče",
          "ERROR": "Toto pole je povinné"
        },
        "API_KEY_SECRET": {
          "LABEL": "API klíč tajemství",
          "PLACEHOLDER": "Zadejte prosím tajemství vašeho API klíče",
          "ERROR": "Toto pole je povinné"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "SID služby zasílání zpráv",
          "PLACEHOLDER": "Zadejte prosím SID vaší Twilio služby pro zasílání zpráv",
          "ERROR": "Toto pole je povinné",
          "USE_MESSAGING_SERVICE": "Použít službu Twilio pro zasílání zpráv"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Typ kanálu",
          "ERROR": "Vyberte prosím typ vašeho kanálu"
        },
        "AUTH_TOKEN": {
          "LABEL": "Ověřovací token",
          "PLACEHOLDER": "Zadejte svůj ověřovací Token Twilio",
          "ERROR": "Toto pole je povinné"
        },
        "CHANNEL_NAME": {
          "LABEL": "Název schránky",
          "PLACEHOLDER": "Zadejte prosím název schránky",
          "ERROR": "Toto pole je povinné"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonní číslo",
          "PLACEHOLDER": "Zadejte prosím telefonní číslo, ze kterého bude zpráva odeslána.",
          "ERROR": "Zadejte prosím platné telefonní číslo, které začíná znakem `+` a neobsahuje mezery."
        },
        "API_CALLBACK": {
          "TITLE": "URL zpětného volání",
          "SUBTITLE": "Musíte nakonfigurovat URL zpětného volání zprávy v Twilio s URL uvedenou zde."
        },
        "SUBMIT_BUTTON": "Vytvořit Twilio kanál",
        "API": {
          "ERROR_MESSAGE": "Nebyli jsme schopni ověřit přihlašovací údaje Twilia, zkuste to prosím znovu"
        }
      },
      "SMS": {
        "TITLE": "SMS kanál",
        "DESC": "Začněte podporovat své zákazníky prostřednictvím SMS.",
        "PROVIDERS": {
          "LABEL": "Poskytovatel API",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth",
          "SMS_BRANA": "SMS Brána",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Nepodařilo se nám uložit SMS kanál"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID účtu",
            "PLACEHOLDER": "Zadejte prosím ID vašeho Bandwidth účtu",
            "ERROR": "Toto pole je povinné"
          },
          "API_KEY": {
            "LABEL": "API klíč",
            "PLACEHOLDER": "Zadejte prosím váš Bandwidth API klíč",
            "ERROR": "Toto pole je povinné"
          },
          "API_SECRET": {
            "LABEL": "API tajemství",
            "PLACEHOLDER": "Zadejte prosím vaše Bandwidth API tajemství",
            "ERROR": "Toto pole je povinné"
          },
          "APPLICATION_ID": {
            "LABEL": "ID aplikace",
            "PLACEHOLDER": "Zadejte prosím ID vaší Bandwidth aplikace",
            "ERROR": "Toto pole je povinné"
          },
          "INBOX_NAME": {
            "LABEL": "Název schránky",
            "PLACEHOLDER": "Zadejte prosím název schránky",
            "ERROR": "Toto pole je povinné"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonní číslo",
            "PLACEHOLDER": "Zadejte prosím telefonní číslo, ze kterého bude zpráva odeslána.",
            "ERROR": "Zadejte prosím platné telefonní číslo, které začíná znakem `+` a neobsahuje mezery."
          },
          "SUBMIT_BUTTON": "Vytvořit Bandwidth kanál",
          "API": {
            "ERROR_MESSAGE": "Nepodařilo se nám ověřit přihlašovací údaje Bandwidth, zkuste to prosím znovu"
          },
          "API_CALLBACK": {
            "TITLE": "URL zpětného volání",
            "SUBTITLE": "Musíte nakonfigurovat URL zpětného volání zprávy v Bandwidth s URL uvedenou zde."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Název schránky",
            "PLACEHOLDER": "Zadejte prosím název schránky",
            "ERROR": "Toto pole je povinné"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonní číslo",
            "PLACEHOLDER": "Zadejte prosím telefonní číslo, ze kterého budou zprávy odesílány.",
            "ERROR": "Zadejte prosím platné telefonní číslo, které začíná znakem `+`."
          },
          "SUBMIT_BUTTON": "Vytvořit SMS Brána kanál",
          "API": {
            "ERROR_MESSAGE": "Nepodařilo se nám vytvořit SMS Brána kanál"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Název schránky",
            "PLACEHOLDER": "Zadejte prosím název schránky",
            "ERROR": "Toto pole je povinné"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonní číslo",
            "PLACEHOLDER": "Zadejte prosím telefonní číslo, ze kterého budou zprávy odesílány.",
            "ERROR": "Zadejte prosím platné telefonní číslo, které začíná znakem `+`."
          },
          "SUBMIT_BUTTON": "Vytvořit DIDWW kanál",
          "API": {
            "ERROR_MESSAGE": "Nepodařilo se nám vytvořit DIDWW kanál"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "Poskytovatel API",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Musíte nakonfigurovat URL webhooku a ověřovací token v portálu Facebook Developer s hodnotami zobrazenými níže.",
          "WEBHOOK_URL": "URL webového háčku",
          "WEBHOOK_VERIFICATION_TOKEN": "Token ověření webhooku"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Rychlé nastavení přes Metu",
          "DESC": "Budete přesměrováni na Metu, kde se přihlásíte ke svému účtu WhatsApp Business. S administrátorským přístupem proběhne nastavení hladce a snadno.",
          "BENEFITS": {
            "EASY_SETUP": "Není potřeba nic nastavovat ručně",
            "SECURE_AUTH": "Bezpečné ověření přes OAuth",
            "AUTO_CONFIG": "Automatické nastavení webhooku a telefonního čísla"
          },
          "SUBMIT_BUTTON": "Připojit WhatsApp Business",
          "AUTH_PROCESSING": "Ověřování u Mety",
          "WAITING_FOR_BUSINESS_INFO": "Dokončete nastavení firmy v okně Mety...",
          "PROCESSING": "Nastavujeme váš účet WhatsApp Business",
          "CANCELLED": "Registrace WhatsApp byla zrušena",
          "WAITING_FOR_AUTH": "Čekání na ověření...",
          "INVALID_BUSINESS_DATA": "Facebook vrátil neplatné údaje o firmě. Zkuste to znovu.",
          "SIGNUP_ERROR": "Při registraci došlo k chybě",
          "SDK_LOAD_ERROR": "Facebook SDK se nepodařilo načíst. Zkuste to znovu.",
          "AUTH_NOT_COMPLETED": "Ověření nebylo dokončeno. Začněte znovu.",
          "SUCCESS_FALLBACK": "Účet WhatsApp Business byl úspěšně nastaven",
          "RECONNECTED": "Kanál WhatsApp byl úspěšně znovu připojen"
        },
        "API": {
          "ERROR_MESSAGE": "Nepodařilo se nám uložit WhatsApp kanál"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API kanál",
        "DESC": "Integrujte s API kanálem a začněte podporovat své zákazníky.",
        "CHANNEL_NAME": {
          "LABEL": "Název kanálu",
          "PLACEHOLDER": "Zadejte název kanálu",
          "ERROR": "Toto pole je povinné"
        },
        "WEBHOOK_URL": {
          "LABEL": "URL webového háčku",
          "SUBTITLE": "Nakonfigurujte URL, kam chcete přijímat zpětná volání o událostech.",
          "PLACEHOLDER": "URL webového háčku"
        },
        "SUBMIT_BUTTON": "Vytvořit API kanál",
        "API": {
          "ERROR_MESSAGE": "Nepodařilo se nám uložit API kanál"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce kanál",
        "DESC": "Integrujte se Salesforce kanálem a začněte podporovat své zákazníky.",
        "CHANNEL_NAME": {
          "LABEL": "Název kanálu",
          "PLACEHOLDER": "Zadejte název kanálu",
          "ERROR": "Toto pole je povinné"
        },
        "API_BASE_URL": {
          "LABEL": "URL Salesforce API",
          "SUBTITLE": "Nakonfigurujte URL, kam chcete přijímat zpětná volání o událostech.",
          "PLACEHOLDER": "URL Salesforce API",
          "ERROR": "Toto pole je povinné"
        },
        "KEY_ID": {
          "LABEL": "ID klíče",
          "SUBTITLE": "ID klíče pro váš Salesforce kanál.",
          "PLACEHOLDER": "KEY ID",
          "ERROR": "Toto pole je povinné"
        },
        "SECRET": {
          "LABEL": "Tajný klíč",
          "SUBTITLE": "Heslo pro váš Salesforce kanál.",
          "PLACEHOLDER": "Secret",
          "ERROR": "Toto pole je povinné"
        },
        "SUBMIT_BUTTON": "Vytvořit Salesforce kanál",
        "API": {
          "ERROR_MESSAGE": "Nepodařilo se nám uložit Salesforce kanál"
        },
        "API_CALLBACK": {
          "TITLE": "URL webhooku",
          "SUBTITLE": "Musíte nakonfigurovat URL webhooku v Salesforce s adresou uvedenou zde."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer Token",
          "SUBTITLE": "Použijte tento bearer token pro autentizaci při konfiguraci webhooku v Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Přepsat odesílatele emailu",
          "SUBTITLE": "Pokud je nastaveno, tato emailová adresa bude použita jako odesílatel pro všechny odchozí emaily místo zdrojového emailu konverzace.",
          "PLACEHOLDER": "např. podpora{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Kanál Allegro",
        "DESC": "Připojte prodejní účet Allegro a odpovídejte na jeho zprávy z kontaktního centra.",
        "CHANNEL_NAME": {
          "LABEL": "Název schránky",
          "SUBTITLE": "Název, který u této schránky uvidí operátoři.",
          "PLACEHOLDER": "Zadejte název schránky",
          "ERROR": "Toto pole je povinné"
        },
        "SUBMIT_BUTTON": "Přihlásit se přes Allegro",
        "API": {
          "ERROR_MESSAGE": "Připojení k Allegro se nezdařilo, zkuste to prosím znovu"
        },
        "SELLER_LOGIN": {
          "TITLE": "Přihlášení Allegro",
          "SUBTITLE": "Prodejní účet, jehož zprávy tato schránka čte a zodpovídá."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kanál Kaufland",
        "DESC": "Odpovídejte na zprávy v ticketech, které vám kupující posílají na tržišti Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Název kanálu",
          "PLACEHOLDER": "Zadejte název kanálu",
          "ERROR": "Toto pole je povinné"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "Client Key o 32 znacích ze stránky nastavení API vašeho prodejního účtu Kaufland.",
          "PLACEHOLDER": "klíč o 32 znacích",
          "ERROR": "Zadejte Client Key o 32 znacích"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "Secret Key o 64 znacích, který patří ke Client Key. Kaufland jej zobrazí jednou a na tuto stránku se už nikdy nevrací.",
          "PLACEHOLDER": "klíč o 64 znacích",
          "ERROR": "Zadejte Secret Key o 64 znacích"
        },
        "SUBMIT_BUTTON": "Vytvořit kanál Kaufland",
        "API": {
          "ERROR_MESSAGE": "Kanál Kaufland se nepodařilo uložit"
        },
        "DISCONNECTED": {
          "TITLE": "Odpojeno",
          "MESSAGE": "Kaufland odmítl tyto API klíče. Zadejte Client Key a Secret Key znovu a kanál se znovu připojí."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "E-mailový kanál",
        "DESC": "Integrujte svou e-mailovou schránku.",
        "CHANNEL_NAME": {
          "LABEL": "Název kanálu",
          "PLACEHOLDER": "Zadejte název kanálu",
          "ERROR": "Toto pole je povinné"
        },
        "EMAIL": {
          "LABEL": "E-mailová adresa",
          "SUBTITLE": "E-mail, kam vám zákazníci posílají podpůrné tikety",
          "PLACEHOLDER": "E-mailová adresa"
        },
        "SUBMIT_BUTTON": "Vytvořit e-mailový kanál",
        "API": {
          "ERROR_MESSAGE": "Nepodařilo se nám uložit e-mailový kanál"
        },
        "FINISH_MESSAGE": "Začněte přeposílat své e-maily na následující e-mailovou adresu."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE kanál",
        "DESC": "Integrujte s LINE kanálem a začněte podporovat své zákazníky.",
        "CHANNEL_NAME": {
          "LABEL": "Název kanálu",
          "PLACEHOLDER": "Zadejte název kanálu",
          "ERROR": "Toto pole je povinné"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE ID kanálu",
          "PLACEHOLDER": "LINE ID kanálu"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE tajemství kanálu",
          "PLACEHOLDER": "LINE tajemství kanálu"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE token kanálu",
          "PLACEHOLDER": "LINE token kanálu"
        },
        "SUBMIT_BUTTON": "Vytvořit LINE kanál",
        "API": {
          "ERROR_MESSAGE": "Nepodařilo se nám uložit LINE kanál"
        },
        "API_CALLBACK": {
          "TITLE": "URL zpětného volání",
          "SUBTITLE": "Musíte nakonfigurovat URL webhooku v LINE aplikaci s URL uvedenou zde."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram kanál",
        "DESC": "Integrujte s Telegram kanálem a začněte podporovat své zákazníky.",
        "BOT_TOKEN": {
          "LABEL": "Bot token",
          "SUBTITLE": "Nakonfigurujte token bota, který jste získali od Telegram BotFather.",
          "PLACEHOLDER": "Bot token"
        },
        "SUBMIT_BUTTON": "Vytvořit Telegram kanál",
        "API": {
          "ERROR_MESSAGE": "Nepodařilo se nám uložit Telegram kanál"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Telefonní hovory",
        "DESC": "Nastavte, které hovory se budou zobrazovat v této schránce.",
        "NAME": {
          "LABEL": "Název schránky",
          "SUBTITLE": "Slouží pro vaši orientaci."
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonní číslo",
          "SUBTITLE": "Zadejte telefonní číslo patřící pod tuto schránku, další čísla můžete přidat později.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Vytvořit schánku hovorů",
        "API": {
          "ERROR_MESSAGE": "Schánku se nepodařilo vytvořit"
        }
      },
      "AUTH": {
        "TITLE": "Vyberte kanál",
        "DESC": "Chat podporuje live-chat widgety, Facebook Messenger, WhatsApp, e-maily atd. jako kanály. Pokud chcete vytvořit vlastní kanál, můžete ho vytvořit pomocí API kanálu. Pro začátek vyberte jeden z kanálů níže."
      },
      "AGENTS": {
        "TITLE": "Agenti",
        "DESC": "Zde můžete přidat agenty ke správě nově vytvořené schránky. Pouze tito vybraní agenti budou mít přístup do vaší schránky. Agenti, kteří nejsou součástí této schránky, nebudou moci při přihlášení vidět zprávy v této schránce ani na ně reagovat. <br> <b>PS:</b> Jako správce, pokud potřebujete přístup ke všem schránkám, byste se měli přidat jako agent do všech schránek, které vytváříte.",
        "VALIDATION_ERROR": "Přidejte alespoň jednoho agenta do vaší nové schránky",
        "PICK_AGENTS": "Vyberte agenty pro schránku"
      },
      "DETAILS": {
        "TITLE": "Detaily schránky",
        "DESC": "Z rozevíracího seznamu níže vyberte Facebook stránku, kterou chcete připojit k chatu. Můžete také zadat vlastní název schránce pro lepší identifikaci."
      },
      "FINISH": {
        "TITLE": "Nalezeno to!",
        "DESC": "Úspěšně jste dokončili integraci vaší facebookové stránky s chatem. Až příště přijde zákaznická zpráva, konverzace se automaticky objeví ve vaší schránce.<br>Poskytujeme vám také widget skript, který můžete snadno přidat na vaše webové stránky. Jakmile je toto aktivní na vašich webových stránkách, zákazníci vám mohou posílat zprávy přímo z vašich webových stránek bez pomoci externího nástroje a konverzace se objeví přímo zde, na chatu.<br>Skvěle, co? No, určitě se pokusíme být :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Vyberte svého poskytovatele e-mailu",
        "DESCRIPTION": "Vyberte poskytovatele e-mailu ze seznamu níže. Pokud v seznamu nevidíte svého poskytovatele e-mailu, můžete vybrat možnost jiného poskytovatele a poskytnout IMAP a SMTP přihlašovací údaje."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft e-mail",
        "DESCRIPTION": "Klikněte na tlačítko Přihlásit se přes Microsoft pro začátek. Budete přesměrováni na přihlašovací stránku e-mailu. Po přijetí požadovaných oprávnění budete přesměrováni zpět ke kroku vytvoření schránky.",
        "EMAIL_PLACEHOLDER": "Zadejte e-mailovou adresu",
        "SIGN_IN": "Přihlásit se přes Microsoft",
        "ERROR_MESSAGE": "Při připojování k Microsoftu došlo k chybě, zkuste to prosím znovu"
      },
      "GOOGLE": {
        "TITLE": "Google e-mail",
        "DESCRIPTION": "Klikněte na tlačítko Přihlásit se přes Google pro začátek. Budete přesměrováni na přihlašovací stránku e-mailu. Po přijetí požadovaných oprávnění budete přesměrováni zpět ke kroku vytvoření schránky.",
        "SIGN_IN": "Přihlásit se přes Google",
        "EMAIL_PLACEHOLDER": "Zadejte e-mailovou adresu",
        "ERROR_MESSAGE": "Při připojování ke Google došlo k chybě, zkuste to prosím znovu"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Ověřování pomocí Facebooku...",
      "ERROR_FB_LOADING": "Chyba při načítání Facebook SDK. Zakažte prosím všechny blokátory reklam a zkuste to znovu z jiného prohlížeče.",
      "ERROR_FB_AUTH": "Něco se pokazilo, prosím obnovte stránku...",
      "ERROR_FB_UNAUTHORIZED": "Nemáte oprávnění provádět tuto akci.",
      "ERROR_FB_UNAUTHORIZED_HELP": "Ujistěte se, že máte přístup k Facebook stránce s plnou kontrolou. Více o Facebook rolích si můžete přečíst <a href=\" https://www.facebook.com/help/187316341316631\">zde</a>.",
      "ERROR_CHANNEL_CREATION": "Schránku se nepodařilo vytvořit. Zkuste to prosím znovu.",
      "CREATING_CHANNEL": "Vytvářím vaši doručenou poštu...",
      "TITLE": "Konfigurace detailů schránky",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Přidat agenty",
      "ADD_AGENTS": "Přidávání agentů do vaší schránky..."
    },
    "FINISH": {
      "TITLE": "Vaše schránka je připravena!",
      "MESSAGE": "Nyní můžete komunikovat se svými zákazníky prostřednictvím vašeho nového kanálu. Příjemnou podporu",
      "BUTTON_TEXT": "Vezmi mě tam",
      "MORE_SETTINGS": "Další nastavení",
      "WEBSITE_SUCCESS": "Úspěšně jste dokončili vytvoření webového kanálu. Zkopírujte kód zobrazený níže a vložte jej na vaše webové stránky. Když zákazník příště použije živý chat, konverzace se automaticky objeví ve vaší schránce."
    },
    "REAUTH": "Znovu autorizovat",
    "VIEW": "Zobrazit",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Nastavení schránky bylo úspěšně aktualizováno",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Automatické přiřazení bylo úspěšně aktualizováno",
        "ERROR_MESSAGE": "Nemohli jsme aktualizovat nastavení schránky. Zkuste to prosím později."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Povoleno",
        "DISABLED": "Zakázáno"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Povoleno",
        "DISABLED": "Zakázáno"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Povoleno",
        "DISABLED": "Zakázáno"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Jméno odesílatele",
        "SUB_TEXT": "Vyberte jméno zobrazené zákazníkovi, když obdrží e-maily od vašich agentů.",
        "FOR_EG": "Například:",
        "FRIENDLY": {
          "TITLE": "Přátelský",
          "FROM": "z",
          "SUBTITLE": "Přidejte jméno agenta, který poslal odpověď, do jména odesílatele, aby bylo přátelštější."
        },
        "PROFESSIONAL": {
          "TITLE": "Profesionální",
          "SUBTITLE": "Použijte pouze nakonfigurovaný název firmy jako jméno odesílatele v záhlaví e-mailu."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Nakonfigurujte název vaší firmy",
          "PLACEHOLDER": "Zadejte název vaší firmy",
          "SAVE_BUTTON_TEXT": "Uložit"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Povoleno",
        "DISABLED": "Zakázáno"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Povoleno",
        "DISABLED": "Zakázáno"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Žádná"
      },
      "SHOW_WELCOME_SCREEN": {
        "ENABLED": "Povoleno",
        "DISABLED": "Zakázáno"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Povoleno",
        "DISABLED": "Zakázáno"
      },
      "ENABLE_HMAC": {
        "LABEL": "Povolit"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Povoleno",
        "DISABLED": "Zakázáno"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Povoleno",
        "DISABLED": "Zakázáno"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Povolit synchronizaci příchozích e-mailů"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Povolit vlastní e-mailovou doménu (zpoplatněno)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Povolit zpracování komentářů z Facebooku"
      },
      "SIGNATURE": {
        "TITLE": "HTML Podpis",
        "SUB_TEXT": "Tento podpis se přidá na konec každé zprávy odeslané z této schránky.",
        "HTML_CONTENT": "HTML kód",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} je zástupný symbol pro jméno agenta, který odešle e-mail.\n{'{{'}email{'}}'} je zástupný symbol pro e-mailovou adresu agenta, který odešle e-mail.\n{'{{'}position{'}}'} je zástupný symbol pro pozici agenta.\n{'{{'}custom_line{'}}'} je zástupný symbol pro vlastní řádek agenta.\n{'{{'}email_signature_picture{'}}'} se nahradí adresou URL obrázku e-mailového podpisu agenta (nikoli značkou obrázku) — použijte ji jako zdroj obrázku (atribut src značky img).",
        "PREVIEW": "Náhled"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Podpisy podle země",
        "SUB_TEXT": "Odpověď dostane podpis podle země zákazníka.",
        "HELP": "Odpověď se podepíše podle země konverzace: podle obchodu Kauflandu, podle trhu objednávky z Allegra, jinak podle jazyka, kterým zákazník píše. Když zemi nepoznáme nebo pro ni tu podpis chybí, použije se HTML podpis výše. Marketplace zakazují odkazy na web a kontaktní údaje, uveďte proto jen pozdrav a {'{{'}name{'}}'}.",
        "EMPTY": "Zatím nemáte vytvořené podpisy pro konkrétní země, odpovědi proto dostanou HTML podpis výše.",
        "COUNTRY": "Vyberte zemi",
        "ADD": "Přidat podpis pro zemi",
        "REMOVE": "Odebrat"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Předvolba pro telefonní čísla",
        "PLACEHOLDER": "Zadejte předvolbu pro správné směrování hovorů (např. *99)",
        "HELP_TEXT": "Tato předvolba bude automaticky přidána před telefonní čísla kontaktů při vytáčení z této schránky."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Text tlačítka „dořešíme později“",
        "PLACEHOLDER": "např. Toto téma dořešíme přes email. Chci se teď zeptat ještě na něco dalšího.",
        "HELP_TEXT": "Text tlačítka ve widgetu, kterým návštěvník opustí aktuální téma a zeptá se na něco dalšího. Když pole necháte prázdné, použije se výchozí text v jazyce návštěvníka."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Odložit nedovolaný hovor o X minut",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Automaticky odloží zmeškaný hovor po neúspěšném pokusu zavolat zpět o zadaný počet minut. Pro vypnutí nechte prázdné nebo zadejte 0."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Vyřešit zmeškaný hovor po X neúspěšných pokusech o kontakt",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Když se na zmeškaný hovor X-krát nedovoláte zpět, automaticky se vyřeší a přidá se k němu soukromá poznámka. Pro vypnutí nechte prázdné nebo zadejte 0."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Předpřipravené otázky",
        "SUB_TEXT": "Nakonfigurujte předdefinované otázky, které mohou zákazníci použít pro interakci s vašimi agenty.",
        "QUESTIONS_LABEL": "Otázky",
        "ADD_QUESTION": "Přidat otázku",
        "QUESTION": "Otázka",
        "REMOVE": "Odebrat",
        "QUESTION_TEXT": "Text, který se zobrazí v bublině.",
        "QUESTION_TEXT_PLACEHOLDER": "Povinné",
        "QUESTION_PAYLOAD": "Text, který se odešle po kliknutí.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Nepovinné",
        "SAVE": "Uložit",
        "NO_BOT_MESSAGE": "Pokud chcete generovat další nápovědy AI, připojte si bota.",
        "BOT_CONNECTED_MESSAGE": "Našeptávání otázek AI botem můžete aktivovat v jeho",
        "BOT_SETTINGS_LINK": "nastavení"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Alternativní e-maily",
        "SUB_TEXT": "Další adresy, které tato schránka má považovat za vlastní při příjmu přeposlané pošty.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Přidat",
        "REMOVE": "Odebrat",
        "EMPTY": "Žádné alternativní e-maily nejsou nastaveny.",
        "HELP_TEXT": "Pokud bude e-mail doručen na některou z těchto adres jako příjemci, odpovědi se odešlou s touž adresou jako odesílatelem. Ověřte si, že váš odchozí SMTP server povoluje odesílání z těchto adres.",
        "SIGNATURE_LABEL": "Podpis",
        "PRIMARY_SIGNATURE": "Primární (výchozí)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Další podpisy",
        "SUB_TEXT": "Zde definujte další podpisy a poté je přiřaďte alternativním e-mailům níže.",
        "OPTION": "Podpis {number}",
        "ADD": "Přidat podpis",
        "REMOVE": "Odebrat",
        "HELP_TEXT": "Když se odpověď odešle z alternativního e-mailu, použije se místo podpisu schránky jeho přiřazený podpis. Alternativní e-maily ponechané na „Primární (výchozí)“ použijí podpis schránky."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazat",
      "AVATAR_DELETE_BUTTON_TEXT": "Smazat avatar",
      "DELETE_REQUESTED_TOOLTIP": "Tato schránka je označena ke smazání",
      "RESTORE_BUTTON_TEXT": "Obnovit",
      "CONFIRM": {
        "TITLE": "Potvrdit odstranění",
        "MESSAGE": "Opravdu chcete odstranit ",
        "PLACE_HOLDER": "Zadejte prosím {inboxName} pro potvrzení",
        "YES": "Ano, odstranit ",
        "NO": "Ne, zachovat "
      },
      "API": {
        "SUCCESS_MESSAGE": "Schránka byla úspěšně smazána",
        "MARKED_FOR_DELETION_MESSAGE": "Schránka byla označena ke smazání",
        "RESTORE_SUCCESS_MESSAGE": "Schránka byla úspěšně obnovena",
        "ERROR_MESSAGE": "Nelze odstranit doručenou poštu. Opakujte akci později.",
        "RESTORE_ERROR_MESSAGE": "Nelze obnovit schránku. Zkuste to prosím později.",
        "AVATAR_SUCCESS_MESSAGE": "Avatar schránky byl úspěšně smazán",
        "AVATAR_ERROR_MESSAGE": "Nepodařilo se smazat avatar schránky. Zkuste to prosím později."
      }
    },
    "TABS": {
      "SETTINGS": "Nastavení",
      "COLLABORATORS": "Spolupracující",
      "AUTOMATIC_PRIORITY": "Automatická priorita",
      "AUTOMATIC_LABELING": "Automatické štítkování",
      "CONFIGURATION": "Připojení",
      "CAMPAIGN": "Kampaně",
      "PRE_CHAT_FORM": "Formulář před chatem",
      "BUSINESS_HOURS": "Pracovní doba",
      "WIDGET_BUILDER": "Tvůrce widgetu",
      "BOT_CONFIGURATION": "Konfigurace bota",
      "SLA": "SLA"
    },
    "SETTINGS": "Nastavení",
    "FEATURES": {
      "LABEL": "Funkce",
      "DISPLAY_FILE_PICKER": "Povolit nahrávání souborů/příloh do widgetu",
      "DISPLAY_EMOJI_PICKER": "Zobrazit emoji klávenici",
      "ALLOW_END_CONVERSATION": "Umožnit uživatelům uzavřít konverzaci z widgetu",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Zobrazit v hlavičce widgetu tlačítko pro zahájení nové konverzace",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Skrýt vstupní pole, když je zobrazeno tlačítko pro zahájení nové konverzace",
      "USE_INBOX_AVATAR_FOR_BOT": "Použij název schránky a avatar pro bota",
      "ALLOW_OFFLINE_REPLY": "Povolit agentům odesílat zprávy, když je kontakt offline a není k dispozici email",
      "SHOW_HANDOFF_BUTTON": "Zobrazit v hlavičce widgetu tlačítko pro předání na operátora",
      "AUTO_CLOSE_OLD": "Automaticky označovat starší konverzace jako vyřešené",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Automaticky přiřazovat změškané hovory při odchozím hovoru"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Skript widgetu",
      "MESSENGER_SUB_HEAD": "Umístěte toto tlačítko dovnitř HTML tagu body",
      "INBOX_COOPERATORS": "Spolupracující",
      "INBOX_AGENTS": "Agenti",
      "INBOX_TEAMS": "Týmy",
      "SELECT_PLACEHOLDER": "Vyberte",
      "AGENTS_OR_TEAMS_INFO": "Můžete přiřadit buď agenty, nebo týmy - ne obojí současně.",
      "AGENT_ASSIGNMENT": "Přiřazení konverzace",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Aktualizujte nastavení přiřazování konverzací",
      "UPDATE": "Aktualizovat",
      "ENABLE_EMAIL_COLLECT_BOX": "Povolit box pro sběr e-mailů",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Povolit nebo zakázat box pro sběr e-mailů u nové konverzace",
      "AUTO_ASSIGNMENT": "Povolit automatické přiřazení",
      "ENABLE_CSAT": "Povolit CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Povolit CSAT pro každou zprávu",
      "SENDER_NAME_SECTION": "Povolit jméno agenta v e-mailu",
      "ENABLE_CSAT_SUB_TEXT": "Povolit/zakázat CSAT (průzkum spokojenosti zákazníků) po vyřešení konverzace",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Povolit/zakázat možnost CSAT průzkumu pro každou zprávu odeslanou agenty",
      "SENDER_NAME_SECTION_TEXT": "Povolit/zakázat zobrazování jména agenta v e-mailu, pokud je zakázáno, zobrazí se název firmy",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Povolit pokračování konverzace přes e-mail",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Konverzace budou pokračovat přes e-mail, pokud je e-mailová adresa kontaktu k dispozici.",
      "RESPOND_FROM_EMAIL": "Odpovídat z e-mailu",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "E-maily zákazníkovi – odpovědi i přepisy konverzace – se odesílají přes SMTP nastavení vybrané e-mailové schránky, z vybrané adresy (vlastní adresy schránky nebo jejího aliasu), a odpovědi zákazníka se vrátí přes její IMAP adresu.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Přepisy konverzace se odesílají přes SMTP nastavení vybrané e-mailové schránky, z vybrané adresy (vlastní adresy schránky nebo jejího aliasu), a odpovědi na ně se vrátí přes její IMAP adresu. Odpovědi zákazníkovi to neovlivní – tento kanál odpovídá vždy přes své vlastní připojení (Facebook, WhatsApp, SMS, ...).",
      "SHOW_WELCOME_SCREEN": "Zobrazit uvítací obrazovku",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Zobrazit uvítací obrazovku při otevření widgetu. Pokud je zakázáno, widget přejde přímo do zobrazení konverzace.",
      "AUTO_CLOSE_PENDING": "Uzavřít AI konverzace po (hodinách)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Automaticky vyřešit konverzace s AI botem, které jsou neaktivní více než X hodin. Doporučujeme také nastavit Povolit zprávy po vyřešení konverzace na Zakázáno.",
      "LOCK_TO_SINGLE_CONVERSATION": "Omezit na jednu konverzaci",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Povolit nebo zakázat více konverzací pro stejný kontakt v této schránce",
      "INBOX_UPDATE_TITLE": "Nastavení schránky",
      "INBOX_UPDATE_SUB_TEXT": "Aktualizujte nastavení schránky",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Povolit nebo zakázat automatické přiřazování nových konverzací agentům přidaným do této schránky.",
      "HMAC_VERIFICATION": "Ověření identity uživatele",
      "HMAC_DESCRIPTION": "Pro ověření identity uživatele můžete pro každého uživatele předat `identifier_hash`. Můžete vygenerovat HMAC sha256 hash pomocí `identifier` s klíčem zobrazeným zde.",
      "HMAC_ROTATE": {
        "BUTTON": "Vyměnit klíč",
        "TITLE": "Vyměnit tajný klíč?",
        "WARNING": "Současný klíč přestane platit v okamžiku výměny.",
        "WARNING_DETAIL": "Starý a nový klíč nefungují souběžně a starý klíč nelze obnovit.",
        "IMPACT": "Vaše servery musí uživatele podepisovat novým klíčem. Kdo je podepsán starým klíčem, ověřením neprojde. Pokud je ověření identity povinné, nemůže zahájit konverzaci.",
        "CONFIRM": "Vyměnit klíč",
        "CANCEL": "Zrušit",
        "SUCCESS": "Tajný klíč byl vyměněn",
        "ERROR": "Tajný klíč se nepodařilo vyměnit, zkuste to znovu"
      },
      "HMAC_LINK_TO_DOCS": "Více informací najdete zde.",
      "HMAC_MANDATORY_VERIFICATION": "Vynutit ověření identity uživatele",
      "HMAC_MANDATORY_DESCRIPTION": "Pokud je povoleno, požadavky bez `identifier_hash` budou odmítnuty.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Vynutit novou konverzaci při každém načtení widgetu",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Pokud je povoleno, otevření widgetu v novém tabu nebo okně založí novou konverzaci.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Zapomenout kontakt při zahájení nové konverzace",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Pokud je vypnuto, nová konverzace zahájená z widgetu zachová předchozí kontakt.",
      "INBOX_IDENTIFIER": "Identifikátor schránky",
      "INBOX_IDENTIFIER_SUB_TEXT": "Použijte token `inbox_identifier` zobrazený zde pro ověření vašich API klientů.",
      "FORWARD_EMAIL_TITLE": "Přeposlat na e-mail",
      "FORWARD_EMAIL_SUB_TEXT": "Začněte přeposílat své e-maily na následující e-mailovou adresu.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Synchronizace e-mailů",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Povolit automatickou synchronizaci a stahování příchozích e-mailů z této schránky",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Vlastní e-mailová doména",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Povolte, abyste mohli používat vlastní e-mailovou doménu pro odchozí e-maily.",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Více informací najdete zde.",
      "FACEBOOK_COMMENTS_TITLE": "Komentáře z Facebooku",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Povolit zprávy po vyřešení konverzace",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Povolit koncovým uživatelům posílat zprávy i po vyřešení konverzace.",
      "WIDGET_STATUS_LABEL": "Stav widgetu",
      "WIDGET_STATUS_ENABLED": "Zapnutý",
      "WIDGET_STATUS_BUSINESS_HOURS": "Zapnutý v pracovní době",
      "WIDGET_STATUS_DISABLED": "Vypnutý",
      "WIDGET_STATUS_HELP_TEXT": "Nastavte, kdy se má widget zobrazovat návštěvníkům vašich webových stránek",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Aktualizovat nastavení formuláře před chatem",
      "EXPLICIT_CSAT_LOCALE": "Jazyk CSAT a emailů pro zákazníky",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Vyberte jazyk pro všechny emaily zákazníkům včetně CSAT hodnocení, přepisů konverzací a emailových notifikací",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Převzít z účtu",
      "WHATSAPP_CONNECTION": {
        "TITLE": "Připojení WhatsApp",
        "SUBTITLE": "Jak je tato schránka připojená k WhatsAppu.",
        "PROVIDER": "Poskytovatel",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Připojeno přes registraci Meta (embedded signup)",
        "STATUS": "Stav",
        "CONNECTED": "Připojeno",
        "RECONNECT_HINT": "Klikněte na Znovu připojit v pruhu nahoře.",
        "PHONE_NUMBER": "Telefonní číslo",
        "BUSINESS_ACCOUNT": "ID účtu WhatsApp Business",
        "OPEN_MANAGER": "Otevřít ve WhatsApp Manageru",
        "PHONE_NUMBER_ID": "ID telefonního čísla",
        "TEMPLATES": "Šablony zpráv",
        "TEMPLATES_COUNT": "Schváleno {approved} z {total}",
        "TEMPLATES_SYNCED": "Naposledy synchronizováno {date}",
        "TEMPLATES_NOT_SYNCED": "Zatím nesynchronizováno",
        "MANAGE_TEMPLATES": "Spravovat šablony"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Centrum nápovědy",
      "PLACEHOLDER": "Vyberte centrum nápovědy",
      "SELECT_PLACEHOLDER": "Vyberte centrum nápovědy",
      "REMOVE": "Odebrat centrum nápovědy",
      "SUB_TEXT": "Připojit centrum nápovědy ke schránce"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Limit automatického přiřazení",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Zadejte prosím hodnotu větší než 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Omezit maximální počet konverzací z této schránky, které mohou být automaticky přiřazeny agentovi"
    },
    "SLA": {
      "TITLE": "Nastavení SLA",
      "SUB_TEXT": "Nastavte SLA časy odezvy a řešení pro každou úroveň priority konverzace.",
      "LOADING": "Načítání SLA nastavení...",
      "FIELDS": {
        "ACTIVE": "Aktivní",
        "TICKET_PRIORITY": "Priorita ticketu",
        "FIRST_RESPONSE_TIME": "Čas první reakce",
        "EVERY_RESPONSE_TIME": "Čas každé reakce",
        "RESOLUTION_TIME": "Doba vyřešení ticketu",
        "PLACEHOLDER": "např. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "SLA nastavení byly úspěšně aktualizovány.",
        "ERROR_MESSAGE": "Nepodařilo se aktualizovat SLA nastavení. Zkuste to prosím znovu."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Automatická priorita",
      "SUB_TEXT": "Nastavte automatické přiřazování priority na základě obsahu konverzace.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Upozornění na fakturaci",
        "MESSAGE": "Každé vyhodnocení priority bude zpoplatněno. Zkontrolujte prosím detaily vašeho plánu pro informace o cenách."
      },
      "MODE": {
        "OFF": "Vypnuto",
        "ALL_MESSAGES": "Zapnuto pro každou příchozí zprávu",
        "FIRST_MESSAGE": "Zapnuto pouze pro první příchozí zprávu"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Konfigurace úrovní priority",
        "SUB_TEXT": "Nastavte, které úrovně priority mají být povoleny a jejich popisy. Poskytněte jasná kritéria pro AI k určení, kdy má být tato priorita přiřazena."
      },
      "DESCRIPTION_LABEL": "Popis",
      "DESCRIPTION_PLACEHOLDER": "Popište konverzace, co mají být označeny jako priorita {priority}",
      "SET_AS_DEFAULT": "Nastavit jako výchozí prioritu",
      "MULTIPLE_DEFAULTS_WARNING": "Pouze jedna úroveň priority může být nastavena jako výchozí. Prosím zrušte zaškrtnutí ostatních výchozích."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Automatické štítkování",
      "SUB_TEXT": "Nastavte automatické přiřazování štítků na základě obsahu konverzace.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Upozornění na fakturaci",
        "MESSAGE": "Každé vyhodnocení štítků bude zpoplatněno. Zkontrolujte prosím detaily vašeho plánu pro informace o cenách."
      },
      "MODE": {
        "OFF": "Vypnuto",
        "CONVERSATION_OPEN": "Při otevření konverzace",
        "CONVERSATION_CLOSE": "Při uzavření konverzace",
        "ALL_MESSAGES": "Při každé zprávě - bez ohledu na stav",
        "FIRST_MESSAGE": "Při první zprávě - bez ohledu na stav"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Konfigurace štítků",
        "SUB_TEXT": "Nastavte, které štítky mají být k dispozici pro automatické přiřazení a jejich popisy. Poskytněte jasná kritéria pro AI k určení, kdy má být tento štítek aplikován."
      },
      "DESCRIPTION_LABEL": "Popis",
      "DESCRIPTION_PLACEHOLDER": "Popište konverzace, které mají byt označeny štítkem {label}. Pokud ponecháte prázdné, štítek bude aplikován na základě popisu štítku.",
      "NO_LABELS_MESSAGE": "Žádné štítky nebyly nalezeny. Nejprve vytvořte štítky pro povolení automatického štítkování.",
      "CREATE_LABELS_LINK": "Vytvořit štítky"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Znovu autorizovat",
      "SUBTITLE": "Vaše připojení k Facebooku vypršelo, znovu připojte svou Facebook stránku, abyste pokračovali ve službách",
      "MESSAGE_SUCCESS": "Opětovné připojení bylo úspěšné",
      "MESSAGE_ERROR": "Došlo k chybě, zkuste to prosím znovu",
      "PAGE_NOT_GRANTED": "Facebook k této stránce nepovolil přístup. Připojte se facebookovým účtem, který má nad stránkou plnou kontrolu, a stránku v dialogu Facebooku zaškrtněte."
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Formuláře před chatem vám umožňují zachytit informace o uživateli předtím, než začne konverzaci s vámi.",
      "SET_FIELDS": "Pole formuláře před chatem",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Pole",
        "LABEL": "Popisek",
        "PLACE_HOLDER": "Zástupný text",
        "KEY": "Klíč",
        "TYPE": "Typ",
        "REQUIRED": "Povinné"
      },
      "ENABLE": {
        "LABEL": "Povolit formulář před chatem",
        "OPTIONS": {
          "ENABLED": "Ano",
          "DISABLED": "Ne"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Zpráva před chatem",
        "PLACEHOLDER": "Tato zpráva bude viditelná pro uživatele spolu s formulářem"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Návštěvníci by měli poskytnout své jméno a e-mailovou adresu před zahájením chatu"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Nastavte svou dostupnost",
      "SUBTITLE": "Nastavte svou dostupnost na widgetu živého chatu",
      "WEEKLY_TITLE": "Nastavte svou týdenní pracovní dobu",
      "TIMEZONE_LABEL": "Vyberte časové pásmo",
      "UPDATE": "Aktualizovat nastavení pracovní doby",
      "TOGGLE_AVAILABILITY": "Povolit dostupnost firmy pro tuto schránku",
      "UNAVAILABLE_MESSAGE_LABEL": "Zpráva o nedostupnosti pro návštěvníky",
      "TOGGLE_HELP": "Povolení dostupnosti firmy zobrazí dostupné hodiny na widgetu živého chatu, i když jsou všichni agenti offline. Mimo dostupné hodiny mohou být návštěvníci upozorněni zprávou a formulářem před chatem.",
      "DAY": {
        "ENABLE": "Povolit dostupnost pro tento den",
        "UNAVAILABLE": "Nedostupný",
        "HOURS": "hodiny",
        "VALIDATION_ERROR": "Čas zahájení by měl být před časem ukončení.",
        "CHOOSE": "Vyberte"
      },
      "ALL_DAY": "Celý den",
      "SAVE_TO_ALL": "Uložit do pro všechny schránky",
      "SAVE_TO_ALL_TITLE": "Uložit pro všechny schránky",
      "SAVE_TO_ALL_CONFIRM": "Nastavení z tohoto formuláře (aktivace pracovní doby, zpráva o nedostupnosti, časové pásmo i hodiny) bude zkopírováno do všech ostatních schránek kromě e-mailových a telefonních. Opravdu chcete pokračovat?",
      "SAVE_TO_ALL_CANCEL": "Zrušit",
      "SAVE_TO_ALL_YES": "Ano, nastavit všude",
      "SAVE_TO_ALL_SUCCESS": "Pracovní doba byla úspěšně zkopírována do všech schránek",
      "SAVE_TO_ALL_ERROR": "Nastavení pracovní doby se nepodařilo zkopírovat do všech schránek. Zkuste to prosím znovu později."
    },
    "PHONE": {
      "TITLE": "Nastavení telefonu",
      "SUBTITLE": "Nastavte které hovory se budou přiřazovat do této schránky.",
      "UPDATE": "Uložit nastavení",
      "EDIT": {
        "SUCCESS_MESSAGE": "Nastavení telefonu uloženo",
        "ERROR_MESSAGE": "Nastavení se nepodařilo uložit"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Telefonní čísla",
        "SUBTITLE": "Hovory na tyto čísla se přiřadí do této schránky.",
        "PLACEHOLDER": "+445123908635",
        "ADD": "Přidat telefonní číslo"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Nastavte své IMAP údaje",
      "NOTE_TEXT": "Pro povolení SMTP nakonfigurujte prosím IMAP.",
      "UPDATE": "Aktualizovat IMAP nastavení",
      "TOGGLE_AVAILABILITY": "Povolit IMAP konfiguraci pro tuto schránku",
      "TOGGLE_HELP": "Povolení IMAP pomůže uživateli přijímat e-maily",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP nastavení byla úspěšně aktualizována",
        "ERROR_MESSAGE": "Nelze aktualizovat IMAP nastavení"
      },
      "ADDRESS": {
        "LABEL": "Adresa",
        "PLACE_HOLDER": "Adresa (např. imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Uživatelské jméno",
        "PLACE_HOLDER": "Uživatelské jméno"
      },
      "PASSWORD": {
        "LABEL": "Heslo",
        "PLACE_HOLDER": "Heslo"
      },
      "ENABLE_SSL": "Povolit SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Znovu autorizujte svůj účet Microsoft"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Nastavte své SMTP údaje",
      "UPDATE": "Aktualizovat SMTP nastavení",
      "TOGGLE_AVAILABILITY": "Povolit SMTP konfiguraci pro tuto schránku",
      "TOGGLE_HELP": "Povolení SMTP pomůže uživateli odesílat e-maily",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP nastavení byla úspěšně aktualizována",
        "ERROR_MESSAGE": "Nelze aktualizovat SMTP nastavení"
      },
      "ADDRESS": {
        "LABEL": "Adresa",
        "PLACE_HOLDER": "Adresa (např. smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Uživatelské jméno",
        "PLACE_HOLDER": "Uživatelské jméno"
      },
      "PASSWORD": {
        "LABEL": "Heslo",
        "PLACE_HOLDER": "Heslo"
      },
      "DOMAIN": {
        "LABEL": "Doména",
        "PLACE_HOLDER": "Doména"
      },
      "ENCRYPTION": "Šifrování",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Ověřovací režim Open SSL",
      "AUTH_MECHANISM": "Ověřování"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Doručitelnost e-mailů (DNS)",
      "SUB_TITLE": "Každý pracovní den kontrolujeme záznamy SPF, DKIM, DMARC a MX domény {domain}. Když kvůli nějakému z nich přijímající servery vaše odpovědi odmítají nebo je řadí do spamu, administrátoři dostanou e-mail s opravou.",
      "RUN": "Zkontrolovat",
      "RUN_SUCCESS": "Kontrola DNS je hotová",
      "RUN_ERROR": "Kontrolu DNS se nepodařilo spustit, zkuste to prosím znovu",
      "NOT_CHECKED": "Zatím nezkontrolováno.",
      "CHECKED_AT": "Naposledy zkontrolováno {time}.",
      "DNS_UNAVAILABLE": "Při poslední kontrole jmenné servery domény neodpověděly. Výsledek níže je z předchozí kontroly.",
      "SENDER": {
        "SMTP": "Odpovědi se odesílají přes {host}.",
        "PLATFORM": "Odpovědi se odesílají přes naše poštovní servery."
      },
      "STATUS": {
        "OK": "Všechny záznamy jsou v pořádku",
        "WARNING": "Některé záznamy by mohly být lepší",
        "ERROR": "Odpovědi nemusí dojít příjemcům",
        "UNKNOWN": "Neznámý"
      },
      "SEVERITY": {
        "ERROR": "Problém",
        "WARNING": "Upozornění"
      },
      "FIX": "Opravíte to tímto DNS záznamem:",
      "RECORD_TYPE": "Typ",
      "RECORD_HOST": "Název",
      "RECORD_VALUE": "Hodnota",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "Chybí SPF záznam",
          "DESCRIPTION": "Doména neuvádí, které servery smějí odesílat její e-maily. Mnoho poštovních serverů pak vaše odpovědi považuje za spam. Přidejte SPF záznam, který povolí {sender}."
        },
        "spf_multiple": {
          "TITLE": "Doména má {count} SPF záznamy",
          "DESCRIPTION": "Doména smí mít jen jeden SPF záznam. Když jich má víc, přijímající servery SPF ignorují a e-maily často odmítnou. Slučte je do jednoho záznamu."
        },
        "spf_not_authorized": {
          "TITLE": "SPF nepovoluje server, který odesílá vaše odpovědi",
          "DESCRIPTION": "Vaše odpovědi se odesílají přes {sender}, ale SPF záznam domény ho neuvádí. Aktuální záznam: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "SPF záznam potřebuje příliš mnoho DNS dotazů",
          "DESCRIPTION": "Přijímající servery přestanou SPF kontrolovat po {limit} DNS dotazech, ale {sender}, přes který se odesílají vaše odpovědi, přijde na řadu až po {lookups} dotazech. Vaše odpovědi proto SPF nesplní. Přesuňte {sender} na začátek záznamu a odeberte include, které doména už nepoužívá."
        },
        "spf_lookups_others": {
          "TITLE": "Někteří odesílatelé v SPF záznamu jsou za limitem dotazů",
          "DESCRIPTION": "SPF záznam potřebuje {lookups} DNS dotazů, přijímající servery se zastaví po {limit}. Vaše odpovědi se přiřadí včas a projdou, ale e-maily od těchto odesílatelů SPF nesplní: {senders}. Odeberte include, které doména už nepoužívá."
        },
        "spf_malformed": {
          "TITLE": "SPF záznam je chybný",
          "DESCRIPTION": "Přijímající servery nedokážou SPF záznam domény přečíst, takže vaše odpovědi nechrání. Problém je v: {terms}. Nahraďte záznam opraveným."
        },
        "dkim_missing": {
          "TITLE": "Není nastavený podpis DKIM",
          "DESCRIPTION": "Na {selectors} jsme nenašli žádný DKIM klíč. Bez něj nejsou vaše odpovědi podepsané a častěji končí ve spamu. Zapněte u svého poskytovatele e-mailu podepisování DKIM pro doménu."
        },
        "dmarc_missing": {
          "TITLE": "Chybí DMARC záznam",
          "DESCRIPTION": "Velcí poskytovatelé e-mailu jako Gmail a Microsoft očekávají DMARC záznam. Bez něj vaše odpovědi častěji končí ve spamu."
        },
        "dmarc_fails": {
          "TITLE": "DMARC říká příjemcům, ať vaše odpovědi odmítnou",
          "DESCRIPTION": "DMARC politika domény je „{policy}“ a vaše odpovědi neprojdou ani SPF, ani DKIM, takže je příjemci odmítnou nebo přesunou do spamu. Opravte SPF a DKIM výše."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC blokuje odpovědi odeslané přes naše poštovní servery",
          "DESCRIPTION": "Tato schránka odesílá odpovědi přes naše poštovní servery, ale DMARC politika domény je „{policy}“, takže je příjemci odmítnou nebo přesunou do spamu. Nastavte pro tuto schránku SMTP vlastního poštovního serveru."
        },
        "mx_missing": {
          "TITLE": "Doména nemá MX záznam",
          "DESCRIPTION": "Bez MX záznamu nikdo nemůže na doménu poslat e-mail, takže zákazníci nemohou na vaše odpovědi odpovědět."
        }
      }
    },
    "NOTE": "Poznámka: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Avatar webových stránek",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar byl úspěšně smazán",
              "ERROR_MESSAGE": "Došlo k chybě, zkuste to prosím znovu"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Název webových stránek",
          "PLACE_HOLDER": "Zadejte název vašich webových stránek (např. Acme Inc)",
          "ERROR": "Zadejte prosím platný název webových stránek"
        },
        "WELCOME_HEADING": {
          "LABEL": "Nadpis uvítání",
          "PLACE_HOLDER": "Ahoj!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Text pro uvítání",
          "PLACE_HOLDER": "Snadno se s námi spojujeme. Požádejte nás o cokoliv, nebo sdílejte svou zpětnou vazbu."
        },
        "REPLY_TIME": {
          "LABEL": "Čas odpovědi",
          "IN_A_FEW_MINUTES": "Do několika minut",
          "IN_A_FEW_HOURS": "Do několika hodin",
          "IN_A_DAY": "Do dne"
        },
        "WIDGET_COLOR_LABEL": "Barva widgetu",
        "WIDGET_BUBBLE_POSITION_LABEL": "Pozice bubliny widgetu",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Maximální výška nepřečtených zpráv (px)",
          "PLACE_HOLDER": "Bez omezení",
          "HELP_TEXT": "Omezte maximální výšku vyskakovacího okna nepřečtených zpráv v pixelech. Ponechte prázdné pro výchozí chování (bez omezení)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Typ bubliny widgetu",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Napište nám",
          "LABEL": "Název spouštěče bubliny widgetu",
          "PLACE_HOLDER": "Napište nám"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Aktualizovat nastavení widgetu",
          "API": {
            "SUCCESS_MESSAGE": "Nastavení widgetu byla úspěšně aktualizována",
            "ERROR_MESSAGE": "Nelze aktualizovat nastavení widgetu"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Náhled",
          "SCRIPT": "Skript"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Vlevo",
          "RIGHT": "Vpravo"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standardní",
          "EXPANDED_BUBBLE": "Rozšířená bublina"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Výchozí",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Většinou odpovíme během pár minut",
        "IN_A_FEW_HOURS": "Většinou odpovíme během pár hodin",
        "IN_A_DAY": "Obvykle odpoví za den"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Zahájit konverzaci",
        "CHAT_INPUT_PLACEHOLDER": "Zde začněte psát"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Jsme online",
          "OFFLINE": "V současné době jsme pryč"
        },
        "USER_MESSAGE": "Ahoj",
        "AGENT_MESSAGE": "Dobrý den"
      },
      "BRANDING_TEXT": "Powered by JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Jiní poskytovatelé"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Webové stránky",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brána",
      "DIDWW": "DIDWW",
      "EMAIL": "E-mail",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API kanál",
      "PHONE": "Telefonie",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
